import './css/styles.scss';

function showCatMenu() {
	const catMenu = document.querySelector('.kategori-widget-mob');
	const catMenuBtn = document.querySelector('.kategori-toggle-top');
	
	if (!catMenu || !catMenuBtn) return;

	catMenuBtn.addEventListener('click', function (e) {
		e.preventDefault();
		catMenu.classList.toggle('is-open');
		this.classList.toggle('is-open');
		const icon = this.querySelector('.plus-icon');
		if (icon) icon.classList.toggle('rotate');
	});
}

function catMenyOpen() {
	const toggles = document.querySelectorAll('.kategori-toggle-mob');

	// ✅ Restore all previously opened categories
	const openCategories = JSON.parse(localStorage.getItem('openWooCategories') || '[]');
	openCategories.forEach(openId => {
		const target = document.getElementById(openId);
		if (target) {
			target.classList.add('is-open');

			const toggle = document.querySelector(`.kategori-toggle-mob[data-target="${openId}"]`);
			if (toggle) {
				const icon = toggle.querySelector('.plus-icon');
				if (icon) icon.classList.add('rotate');
			}
		}
	});

	// ✅ Set up all toggles
	toggles.forEach(button => {
		button.addEventListener('click', function (e) {
			e.preventDefault();

			const targetId = this.getAttribute('data-target');
			const childContainer = document.getElementById(targetId);
			const icon = this.querySelector('.plus-icon');

			if (!targetId || !childContainer) return;

			childContainer.classList.toggle('is-open');
			if (icon) icon.classList.toggle('rotate');

			// ✅ Get stored list from localStorage
			let stored = JSON.parse(localStorage.getItem('openWooCategories') || '[]');

			if (childContainer.classList.contains('is-open')) {
				if (!stored.includes(targetId)) {
					stored.push(targetId);
				}
			} else {
				stored = stored.filter(id => id !== targetId);
			}

			// ✅ Update localStorage
			localStorage.setItem('openWooCategories', JSON.stringify(stored));
		});
	});
}


// on dom ready
document.addEventListener('DOMContentLoaded', () => {
	catMenyOpen();
	showCatMenu();
});
